
WB.WidgetGrids = WB.WidgetGrids || {};

WB.WidgetGrids.WidgetGridOneDirectiveLink = function (scope, element, attr) {
};

WB.WidgetGrids.WidgetGridOneDirective = function () {
    return {
        scope: {
            grid: '='
        },
        restrict: 'AE',
        link: WB.WidgetGrids.WidgetGridOneDirectiveLink,
        template: `<ul class="widget-grid js-widget-grid" data-layout-id="{{ grid.LayoutId }}">
        <div
            wb-widget-grid-widget-item
            widget="grid.Widgets[0]"></div>
        <li class="widget-grid__widget-container" data-container-position="2">
            <ul class="widget-grid__widget-container__rows block-list" data-rows="2">
                <div
                    wb-widget-grid-widget-item
                    widget="grid.Widgets[1]"></div>
                <div
                    wb-widget-grid-widget-item
                    widget="grid.Widgets[2]"></div>
                <div
                    wb-widget-grid-widget-item
                    widget="grid.Widgets[3]"></div>
                <li class="widget-grid__widget-container" data-container-position="6">
                    <ul class="widget-grid__widget-container__rows block-list" data-rows="2">
                        <div
                            wb-widget-grid-widget-item
                            widget="grid.Widgets[4]"></div>
                        <div
                            wb-widget-grid-widget-item
                            widget="grid.Widgets[5]"></div>
                    </ul>
                </li>
            </ul>
        </li>
        <div
            wb-widget-grid-widget-item
            widget="grid.Widgets[6]"></div>
        <div
            wb-widget-grid-widget-item
            widget="grid.Widgets[7]"></div>
        <div
            wb-widget-grid-widget-item
            widget="grid.Widgets[8]"></div>
        <div
            wb-widget-grid-widget-item
            widget="grid.Widgets[9]"></div>
        <div
            wb-widget-grid-widget-item
            widget="grid.Widgets[10]"></div>
        <div
            wb-widget-grid-widget-item
            widget="grid.Widgets[11]"></div>
        <div
            wb-widget-grid-widget-item
            widget="grid.Widgets[12]"></div>
    </ul>`
    };
};
WB.App.directive('wbWidgetGridOne', WB.WidgetGrids.WidgetGridOneDirective);
